import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import {
  getPlanSubscriptionStatus,
  getBusinessId,
} from 'constants/localStorageManager';
import 'assets/scss/header.css';

import BusinessApi from 'apis/Business';
import Toaster from '../Toaster';

const returnSingularorPlural = data => {
  let name = Object.keys(data);
  if (data[name] <= 1) name = name.replace(/.$/, '');
  return `${name} `;
};

const getCountDownString = (date = {}) => {
  const { days, hours, minutes } = date;
  let daysText = '';
  let hourText = '';
  let minutesText = '';

  if (parseInt(days) > 0) {
    daysText = `${days} ${returnSingularorPlural({ days })}`;
  }
  if ((parseInt(hours) > 0 && !daysText) || daysText) {
    hourText = `${hours} ${returnSingularorPlural({ hours })}`;
  }
  minutesText = `${minutes} ${returnSingularorPlural({ minutes })}`;

  return `${daysText}${hourText}${minutesText}`;
};

const secondsToCountDown = timeInSeconds => {
  let seconds = timeInSeconds;
  if (!seconds) return;
  const days = Math.floor(seconds / (24 * 3600));

  seconds %= 24 * 3600;
  const hours = Math.floor(seconds / 3600);

  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);

  seconds %= 60;

  return getCountDownString({
    days,
    hours,
    minutes,
  });
};

class PendingCancellationBanner extends Component {
  constructor() {
    super();
    this.state = {
      businessPlan: {},
      timeUntilCancellation: null,
    };
    this.timer = null;
  }

  componentDidMount() {
    const businessPlan = getPlanSubscriptionStatus() || {};
    this.setState({ businessPlan }, this.setCountDown);
  }

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  setCountDown = () => {
    const { businessPlan } = this.state;
    const { cancellation_scheduled_on } = businessPlan;
    if (!cancellation_scheduled_on) return;
    const endDate = moment(cancellation_scheduled_on).endOf('month');
    this.timer = setInterval(() => {
      const timeUntilCancellation = endDate.diff(moment(), 'second');
      const time = secondsToCountDown(timeUntilCancellation);
      this.setState({ timeUntilCancellation: time });
    }, 1000);
  };

  reactivateAccount = () => {
    const {
      match: { params },
      fetchUserData,
    } = this.props;
    let { businessId, id } = params;
    businessId = getBusinessId() || businessId || id;
    const planSubscription = getPlanSubscriptionStatus() || {};

    const reactivateData = {
      business: {
        plan_subscription_attributes: {
          ...planSubscription,
          status: 'active',
          cancellation_scheduled_on: null,
        },
      },
    };

    BusinessApi.update(businessId, reactivateData)
      .then(({ data }) => {
        const { plan_subscription } = data;
        this.setState({ businessPlan: plan_subscription });
        Toaster.getSuccessToaster('check-circle', 'Reactivation successfull');
        fetchUserData();
      })
      .catch(e => {
        const { error } = e.response.data;
        Toaster.getErrorToaster('exclamation-triangle', error || 'Error');
      });
  };

  render() {
    const { businessPlan, timeUntilCancellation } = this.state;
    const { status } = businessPlan;
    const isPendingCancellation = status === 'pending_cancellation';
    if (!isPendingCancellation || !timeUntilCancellation) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="top-message-banner">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <p className="pt-3 d-inline ml-3">
                  {`Your subscription will be cancelled in ${timeUntilCancellation}.`}
                </p>
                <button className="btn ml-4" onClick={this.reactivateAccount}>
                  I change my mind
                </button>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(PendingCancellationBanner);



// WEBPACK FOOTER //
// ./src/components/Banners/pendingCancellation.js